module.exports = "img/flags/CA.17ef24f.png";